import { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { toAudString } from 'utils/currency';
import { PaymentPageContext } from 'components/Payment/PaymentPageProvider';
import { Tickets } from './Tickets';
import { Donations } from './Donations';
import { GiftVouchers } from './GiftVouchers';
import { Membership } from './Membership';
import { Fees } from './Fees';
import { RedeemedVouchers } from './RedeemedVouchers';

import './Cart.scss';

export const Cart = (props) => {
  const { currentCartModel, showTotal, stepName } = props;
  const { order: updatedOrder } = useContext(PaymentPageContext);
  const [order, setOrder] = useState(currentCartModel.Order);

  useEffect(() => {
    if (updatedOrder) {
      setOrder(updatedOrder);
    }
  }, [updatedOrder]);

  return (
    <div className="cart-table-wrap" data-testid="cart">
      <Tickets
        items={order.Cart.PerformanceTickets.map(
          (ticket, i) => ({ ...ticket, ...currentCartModel.OrderDataLayer.PerformanceTickets[i] })
        )}
        stepName={stepName}
      />
      <Donations items={order.Cart.DonationItems} stepName={stepName} />
      <GiftVouchers items={order.Cart.PurchasedGiftCertificates} stepName={stepName} />
      <Membership items={order.Cart.MembershipItems} stepName={stepName} />

      {/* Original subtotal */}
      {order.Cart.OriginalOrderSubTotal > order.Cart.OrderSubTotal && (
        <div className="cart-total-wrap cart-org-subtotal">
          <div className="row">
            <div className="col-sm-4 pull-right cell-price text-right">
              <div className="row-heading">Original Subtotal</div>
              <span className="price-old">{toAudString(order.Cart.OriginalOrderSubTotal)}</span>
            </div>
          </div>
        </div>
      )}

      {/* Cart subtotal */}
      <div className="cart-total-wrap cart-total">
        <div className="row">
          <div className="col-sm-4 pull-right cell-price text-right">
            <div className="row-heading">Cart Subtotal</div>
            {toAudString(order.Cart.OrderSubTotal)}
          </div>
        </div>
      </div>

      <Fees items={order.Cart.Fees} />
      <RedeemedVouchers items={order.Cart.RedeemedGiftCertificates} stepName={stepName} />

      {/* Cart total */}
      {showTotal && (
        <div className="cart-total-wrap">
          <div className="row">
            <div className="col-sm-4 pull-right cell-price text-right">
              <div className="row-heading">
                <strong>Order total</strong>
              </div>
              <div className="price-">{toAudString(order.Cart.OrderTotal)}</div>
              <p>
                <span className="info-label">
                  <small className="cart-disclaim">Price is inclusive of GST</small>
                </span>
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export const CartSC = (props) => {
  const { sitecoreData, stepName, showTotal } = props;
  return <Cart stepName={stepName} showTotal={showTotal} currentCartModel={sitecoreData} />;
};

CartSC.propTypes = {
  sitecoreData: PropTypes.object.isRequired,
  showTotal: PropTypes.bool,
  stepName: PropTypes.string,
};

Cart.propTypes = {
  currentCartModel: PropTypes.object.isRequired,
  showTotal: PropTypes.bool,
  stepName: PropTypes.string,
};

Cart.defaultProps = {
  showTotal: true,
  stepName: 'Cart',
};
